import { ILegalEntitiesListLoadSuccessPayload } from './actions.types';

const DOCUMENT = 'LEGAL_ENTITIES_LIST_';

const actions = {
  LOAD_REQUEST: `${DOCUMENT}LOAD_REQUEST`,
  LOAD_SUCCESS: `${DOCUMENT}LOAD_SUCCESS`,
  LOAD_ERROR: `${DOCUMENT}LOAD_ERROR`,
  CLEAR_STORE: `${DOCUMENT}CLEAR_STORE`,

  loadDataRequest: (data: Record<string, unknown> = {}) => ({
    type: actions.LOAD_REQUEST,
    payload: data,
  }),

  loadDataSuccess: (data: ILegalEntitiesListLoadSuccessPayload) => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadDataError: () => ({
    type: actions.LOAD_ERROR,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
